import { Where } from '@va/types/filters';
import { Direction, Pagination } from '@va/types/table';
import { WithRequired } from '@va/types/util';
import { PageTypeEnum } from '@va/types/website';
import { isWixApp } from '@va/util/helpers';

export type ConversionEventValueType<T extends ConversionEventTypes | any = any> = {
  id?: string;
  name?: string;
  createdAt?: string;
  createdBy?: string;
  kind: (typeof ConversionEventKind)[keyof typeof ConversionEventKind];
  data?: T extends ConversionEventTypes ? ConversionEventValues[T] : any;
  conversionValue?: number | null;
  dailyConversionGoal?: number | null;
  note?: string;
};

export enum ConversionEventTypes {
  AutoEvents = 'auto_event',
  CustomEvents = 'custom_event',
  ECommerceEvents = 'ecom_event',
  OutgoingTraffic = 'outgoing_traffic',
  WebsitePageUrl = 'website_page',
  CustomUrlPattern = 'url_pattern',
  // Funnel = 'funnel',
}

export const ConversionEventTypeNames = isWixApp()
  ? {
      [ConversionEventTypes.WebsitePageUrl]: 'websitePage',
      [ConversionEventTypes.CustomUrlPattern]: 'urlPattern',
      [ConversionEventTypes.OutgoingTraffic]: 'outgoingTraffic',
      [ConversionEventTypes.AutoEvents]: 'autoEvent',
      // [ConversionEventTypes.Funnel]: 'funnel',
    }
  : {
      [ConversionEventTypes.WebsitePageUrl]: 'websitePage',
      [ConversionEventTypes.CustomUrlPattern]: 'urlPattern',
      [ConversionEventTypes.CustomEvents]: 'customEvent',
      [ConversionEventTypes.ECommerceEvents]: 'ecomEvent',
      [ConversionEventTypes.OutgoingTraffic]: 'outgoingTraffic',
      [ConversionEventTypes.AutoEvents]: 'autoEvent',
      // [ConversionEventTypes.Funnel]: 'funnel',
    };

export const ConversionEventKind = isWixApp()
  ? {
      [ConversionEventTypes.WebsitePageUrl]: 'website_page',
      [ConversionEventTypes.CustomUrlPattern]: 'url_pattern',
      [ConversionEventTypes.OutgoingTraffic]: 'outgoing_traffic',
      [ConversionEventTypes.AutoEvents]: 'auto_event',
      // [ConversionEventTypes.Funnel]: 'funnel',
    }
  : {
      [ConversionEventTypes.WebsitePageUrl]: 'website_page',
      [ConversionEventTypes.CustomUrlPattern]: 'url_pattern',
      [ConversionEventTypes.CustomEvents]: 'custom_event',
      [ConversionEventTypes.ECommerceEvents]: 'ecom_event',
      [ConversionEventTypes.OutgoingTraffic]: 'outgoing_traffic',
      [ConversionEventTypes.AutoEvents]: 'auto_event',
      // [ConversionEventTypes.Funnel]: 'funnel',
    };

export type UrlPatternQueryParam = {
  name: string;
  value?: string;
};

export type ConversionEventValues = {
  [ConversionEventTypes.AutoEvents]: {
    action: string;
    category: string;
    label: string;
    value: string;
    triggerURLs: string[];
  };
  [ConversionEventTypes.CustomEvents]: {
    action?: string;
    category: string;
    label?: string;
    value?: string;
    fieldsObject?: string;
    triggerURLs?: string[];
  };
  [ConversionEventTypes.ECommerceEvents]: {
    type: string[];
    triggerURLs?: string[];
  };
  [ConversionEventTypes.OutgoingTraffic]: {
    url: string;
  };
  [ConversionEventTypes.WebsitePageUrl]: {
    type?: PageTypeEnum;
    url: string;
  };
  [ConversionEventTypes.CustomUrlPattern]: {
    match: string;
    url: string;
    queryParams?: UrlPatternQueryParam[];
  };
  // [ConversionEventTypes.Funnel]: {
  //   funnelId: string;
  // };
};

export enum FormFieldNames {
  name = 'name',
  kind = 'kind',
  data = 'data',
  conversionValue = 'conversionValue',
  dailyConversionGoal = 'dailyConversionGoal',
  note = 'note',
}

export type ConversionEventsResponse = {
  payload: WithRequired<ConversionEventValueType, 'id' | 'name'>[];
  meta: {
    pageSize: number;
    total: number;
    page: number;
  };
};

export type Order = Array<{
  member: (typeof SortableMembers)[number];
  direction: Direction;
}>;

export const SortableMembers = ['createdAt', 'createdBy', 'note', 'conversionValue', 'dailyConversionGoal'];

export type UseConversionEventsDataParams = {
  pagination: Pagination;
  order: Order | undefined;
};

export type UseConversionEventsDataFetchParams = {
  url: string;
  body: {
    where: Where;
  };
};

export enum conversionEventsSelectOptions {
  all = 0,
}

export type ConversionValue = {
  id: string;
  conversionEventId: string;
  websiteKey: string;
  value: number;
  createdAt: string;
  createdBy: string;
};

export type UseConversionValueHistoryResponse = {
  payload: ConversionValue[] | null;
  meta: {
    total: number;
    page: number;
    pageTotal: number;
    pageSize: number;
  };
};

export type ConversionValueHistory = {
  items: ConversionValue[];
  total: number;
};
